
export const businessEmail = "xiecheng1@3975.com"
export const businessList = [
    {
        name: "决战商务合作",
        qq: "602371286",
        phone: "13771792738",
        mailbox: "gaoqiang@jyqianyou.com",
    },
    {
        name: "决战商务合作",
        qq: "289456176",
        phone: "13373607397",
        mailbox: "malin@qianyouqn.com",
    },
    {
        name: "决战商务合作",
        qq: "594843422",
        phone: "19852886295",
        mailbox: "shihaojie@jyqianyou.com",
    },
    {
        name: "决战商务合作",
        qq: "3031446971",
        phone: "15251591812",
        mailbox: "pan@jyqianyou.com",
    },
    {
        name: "决战商务合作",
        qq: "649265011",
        phone: "18576468073",
        mailbox: "shenzhuocheng@3975.com",
    },
]